import * as React from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Switch, TableCell, TableRow} from "@mui/material";
import {BiArchiveIn, BiArchiveOut} from "react-icons/bi";
import {FiEdit} from "react-icons/fi";
import CampaignsSelectCampaignArea from "./CampaignsSelectCampaignArea";
import CampaignsShowAddCampaignNumbers from "./CampaignsShowAddCampaignNumbers";
import CampaignsPostcodes from "./CampaignsPostcodes";
import CampaignVets from "./CampaignsVets";
import CampaignsSendNotificationNewCampaigns from "./CampaignsSendNotificationNewCampaigns";
import CampaignsAddCampaign from "./CampaignsAddCampaign";
import CampaignOptedVets from "./CampaignsOptedVets";

export default function CampaignsShowTableRow({row,setRow,community,inspectors,outreach, voucherMessage, setVoucherMessage, setLoading, updateCampaigns, tags, vets}) {

    const [isOpenRow, setIsOpenRow] = React.useState(false);
    const [btnAddDisabled, setBtnAddDisabled] = React.useState(false);
    const [numberVoucher, setNumberVouchers] = React.useState('');

    async function addVouchers(numVouchers) {
        setBtnAddDisabled(true)
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/campaign/vouchers/add'),
            {
                howMany: parseInt(numVouchers),
                campaignIdMerco: row.merco_id,
                campaignId: row.id
            }
        )
            .then((r) => {
                setVoucherMessage(
                    {...voucherMessage, [row.id]: String(r.data)}
                );
                setLoading(true)
            })
            .then(() => setBtnAddDisabled(false));
    }

    return (
        <>
            <TableRow key={row.id}>
                <TableCell sx={{width: '50px'}} align="center">
                    <Switch checked={row.active > 0}
                            onChange={(e) => updateCampaigns('active', e.target.checked, row.id)}/>
                </TableCell>
                <TableCell align="left">
                    {row.name}&nbsp;
                    <a href={""} onClick={(e) => {
                        e.preventDefault();
                        setIsOpenRow(true)
                    }}><FiEdit size={15}/>
                    </a>
                    <CampaignsSelectCampaignArea row={row} />
                </TableCell>
                <TableCell align="left" sx={{whiteSpace: 'nowrap'}}>
                    {row.all_vouchers} provisioned<br/>
                    {row.issued_vouchers} issued<br/>
                    {row.redeemed_vouchers} redeemed<br/>
                    {row.all_vouchers - row.issued_vouchers} available
                </TableCell>
                <TableCell align="left" style={{whiteSpace: 'nowrap'}}>
                    Merco ID: {row.merco_id}
                    <CampaignsShowAddCampaignNumbers row={row}
                                                     addVouchers={addVouchers}
                                                     numberVoucher={numberVoucher}
                                                     setNumberVouchers={setNumberVouchers}
                                                     btnAddDisabled={btnAddDisabled}
                                                     voucherMessage={voucherMessage}
                    />
                </TableCell>
                <TableCell align="left">
                    <CampaignsPostcodes tags={tags} row={row}/>
                </TableCell>
                <TableCell align="left">
                    <CampaignVets campaignData={row} setLoading={setLoading} vets={vets}/>
                </TableCell>
                {!outreach && (
          <TableCell>
            <CampaignOptedVets campaignData={row} setLoading={setLoading} vets={vets} />
          </TableCell>
        )}
                <TableCell align="left">
                    <CampaignsSendNotificationNewCampaigns {...{row,setLoading}} />
                </TableCell>
                <TableCell align="left">
                    {new Date(String(row.start_date)).toLocaleDateString('en-NZ')}
                </TableCell>
                <TableCell align="left">
                    {new Date(String(row.end_date)).toLocaleDateString('en-NZ')}
                </TableCell>
                <TableCell align="center">
                    {(row.archived > 0) ?
                        <a href={""}
                           onClick={(e) => {
                               e.preventDefault();
                               updateCampaigns('archived', 0, row.id);
                           }}>
                            <BiArchiveOut size={30}/>
                        </a>
                        :
                        <a href={""}
                           onClick={(e) => {
                               e.preventDefault();
                               updateCampaigns('archived', 1, row.id);
                           }}>
                            <BiArchiveIn size={30}/>
                        </a>
                    }
                </TableCell>
            </TableRow>
            <CampaignsAddCampaign setLoading={setLoading}
                                  setIsOpen={setIsOpenRow}
                                  isOpen={isOpenRow}
                                  currentData={row}
                                  setCurrentData={setRow}
                                  mode={"update"}
                                  community={community}
                                  inspectors={inspectors}
                                  outreach={outreach}
            />
        </>
    )
}
